import PeHeading from './PeHeading';

export default PeHeading;
